import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "offcanvas-header-action"
}
const _hoisted_2 = { class: "offcanvas-body" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "text-pagesubtitle" }
const _hoisted_5 = { class: "text-paragraph" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Próxima", -1)
const _hoisted_8 = { class: "text-subtitle mb-2" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "text-label text-primary50 mb-0 me-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right text-primary ms-auto fa-lg" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Realizadas", -1)
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "text-subtitle mb-2" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "text-label text-primary50 mb-0 me-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right text-primary ms-auto fa-lg" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.recurrency?.status === 'active')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", {
            class: "text-subtitle cursor-pointer text-danger mb-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCancelConfirmed && _ctx.handleCancelConfirmed(...args)))
          }, " Cancelar recorrência ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.recurrency?.title), 1)
            ]),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.recurrency?.description), 1),
            _createElementVNode("p", {
              class: _normalizeClass(["text-subtitle mb-0", _ctx.recurrency?.status_color])
            }, _toDisplayString(`Esta recorrência está ${_ctx.recurrency?.status_label}`), 3),
            _hoisted_6
          ], 64)),
      (_ctx.recurrency.next_appointment)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_7,
            _createElementVNode("div", {
              class: "d-flex py-4 border-bottom align-items-center cursor-pointer mb-4",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAppointment(_ctx.recurrency.next_appointment.id)))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.recurrency.next_appointment.formatted_datetime), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, " R$" + _toDisplayString(_ctx.recurrency.next_appointment.value), 1),
                  _createElementVNode("p", {
                    class: _normalizeClass(["text-label mb-0", _ctx.recurrency.next_appointment.status_color])
                  }, _toDisplayString(_ctx.recurrency.next_appointment.status_label), 3)
                ])
              ]),
              _hoisted_11
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.recurrency.past_appointments)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _hoisted_12,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recurrency.past_appointments, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex py-4 border-bottom align-items-center cursor-pointer",
                onClick: ($event: any) => (_ctx.handleAppointment(item.id)),
                key: index
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_14, _toDisplayString(item.formatted_datetime), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, " R$" + _toDisplayString(item.value), 1),
                    _createElementVNode("p", {
                      class: _normalizeClass(["text-label mb-0", item.status_color])
                    }, _toDisplayString(item.status_label), 3)
                  ])
                ]),
                _hoisted_17
              ], 8, _hoisted_13))
            }), 128))
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 64))
}